import type {
  CipherText,
  RbcInsuranceProduct,
} from "@b2bportal/rbc-insurance-api";
import type { PartialParentContext, ParentState } from "@checkout/index";
import type { ProvinceCode } from "@overrides/utilities";

export interface TripInsuranceContext {
  products: Partial<Record<ProvinceCode, RbcInsuranceProduct[]>>;
  selectedProduct: RbcInsuranceProduct | undefined;
  visited: boolean;
  error: Error | undefined;
  insuranceSelectedState: InsuranceSelectedState;
  provinceCode: ProvinceCode;
  lastFetchedQuoteId: CipherText | undefined;
}

export enum InsuranceSelectedState {
  ADD_TO_TRIP = "addToTrip",
  DECLINE = "decline",
  UNAVAILABLE = "unavailable",
  NOT_SELECTED = "notSelected",
}

export type ParentContextWithTripInsurance = PartialParentContext & {
  [ParentState.insurance]?: TripInsuranceContext;
};
